module.exports = __webpack_public_path__ + "media/images/app/become-vendor/PlayIcon-c67b7a5aa7ddfff139814c15f1575975.svg";